module.exports = __webpack_public_path__ + "img/makco.039bb649.jpg";